/** Estilo compartido de los campos de texto del ingreso, la seguridad y el primer ingreso */
export const inputClass =
  "h-12 w-full rounded-md border border-input-border bg-white px-4 text-[15px] text-ink caret-moss outline-none transition-[border-color,box-shadow] duration-200 placeholder:text-text-3/70 hover:border-text-3 focus:border-moss focus:ring-4 focus:ring-mint-tint aria-invalid:border-danger aria-invalid:ring-4 aria-invalid:ring-danger-tint";

export const labelClass = "text-sm font-semibold text-ink";
